/** Used by the API to indicate that a resource does not have a limit to how many can be created */
export const FEATURE_UNLIMITED_FLAG = -1;
